import { Affix, Button, Card, Form, Space, message } from "antd";
import { BGMEA_UD_AMENDMENT_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BgmeaUdAmendmentForm from "../BgmeaUdAmendmentForm";

const UpdateBgmeaUdAmendment = (props) => {
  const { width, viewMode } = props;
  const [editInfo, setEditInfo] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { bgmeaUdAmendmentId } = useParams();

  const getBgmeaUdAmendmentInfo = useCallback(
    async (id) => {
      const query = `${BGMEA_UD_AMENDMENT_LIST_ENDPOINT}/${id}`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const bgmeaUdAmendmentData = response?.data?.data;
        console.log("API Response for edit:", response?.data);
        console.log("BGMEA UD Amendment Data:", bgmeaUdAmendmentData);
        console.log(
          "Available fields in API data:",
          Object.keys(bgmeaUdAmendmentData || {}),
        );

        form.setFieldsValue({
          name: bgmeaUdAmendmentData?.name,
          description: bgmeaUdAmendmentData?.description,
        });
        setEditInfo(bgmeaUdAmendmentData);
      } else {
        HandleNotification(
          "error",
          "Error!",
          response?.message || "Failed to get BGMEA UD Amendment data",
        );
      }
    },
    [form],
  );

  useEffect(() => {
    if (bgmeaUdAmendmentId) {
      getBgmeaUdAmendmentInfo(bgmeaUdAmendmentId);
    }
  }, [bgmeaUdAmendmentId, getBgmeaUdAmendmentInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/bgmea-ud-amendment");
  };

  const updateBgmeaUdAmendment = () => {
    form.submit();
  };

  const handleDownload = () => {
    if (editInfo?.voucher) {
      const link = document.createElement("a");
      link.href = editInfo.voucher;
      link.download = `bgmea-ud-amendment-voucher-${bgmeaUdAmendmentId}`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("Download started");
    } else {
      message.error("No file available for download");
    }
  };

  const handlePrint = () => {
    if (editInfo?.voucher) {
      try {
        const pdfUrl = process.env.REACT_APP_BASE_URL + "/" + editInfo.voucher;

        const printWindow = window.open(
          pdfUrl,
          "_blank",
          "width=800,height=600",
        );

        if (printWindow) {
          setTimeout(() => {
            message.info({
              content:
                "PDF opened in new tab. Use Ctrl+P (or Cmd+P on Mac) to print.",
              duration: 5,
            });
          }, 1000);

          printWindow.focus();
        } else {
          message.error(
            "Unable to open PDF. Please check your popup blocker settings.",
          );
        }
      } catch (error) {
        console.error("Print error:", error);
        message.error("Print functionality is not available");
      }
    } else {
      message.error("No file available for printing");
    }
  };

  const ActionUI = () => {
    return (
      <Space>
        {/* {viewMode && editInfo?.voucher && (
          <>
            <Button
              size="small"
              icon={<DownloadOutlined />}
              onClick={handleDownload}
              type="default"
            >
              Download
            </Button>
            <Button
              size="small"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              type="default"
            >
              Print
            </Button>
          </>
        )} */}

        <Button size="small" key={1} danger onClick={() => discardForm()}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => updateBgmeaUdAmendment()}
          hidden={viewMode}
        >
          Update BGMEA UD Amendment
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={`${viewMode ? "View" : "Edit"} BGMEA UD Amendment`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      <BgmeaUdAmendmentForm
        form={form}
        isEdit={true}
        viewMode={viewMode}
        editInfo={editInfo}
      />
    </>
  );
};

export default UpdateBgmeaUdAmendment;
